import { render } from "./FacilityArea.vue?vue&type=template&id=f4a8498c"
import script from "./FacilityArea.vue?vue&type=script&lang=js"
export * from "./FacilityArea.vue?vue&type=script&lang=js"
script.render = render

export default script